/**
 * Represents the source of speech recognition invocation.
 */
export enum InvocationSource {
    /**
     * No invocation source specified.
     */
    None = "None",

    /**
     * Voice activation with a keyword.
     */
    VoiceActivationWithKeyword = "VoiceActivationWithKeyword"
}
